import { Outlet } from "react-router-dom";
import "./AdminShell.css";

// Admin navigation lives in NCENavbar (swapped in when the path starts with
// /admin) so there's a single navbar on screen — this shell is just the
// content area.
export default function AdminShell() {
    return (
        <main className="admin-main">
            <Outlet />
        </main>
    );
}
